const US = require('./en-US.json');
const FR = require('./fr-CA.json');
const CA = require('./en-CA.json');

export default {
  'en-US': US,
  'en-CA': CA,
  'fr-CA': FR,
};
